/**
 * Submit GA Actions
 * @todo: move this to redux
 */
import * as gaConstants from '../../constants/ga';
import formurlencoded from 'form-urlencoded';
import root from 'window-or-global';

const getWebview = () => {
	const { __WEBVIEW_STATE__ } = root;
	if(__WEBVIEW_STATE__ && (__WEBVIEW_STATE__ == 'android' || __WEBVIEW_STATE__ == 'ios')){
		return __WEBVIEW_STATE__;
	}
	return false;
}

const setTracker = () => {
  try {
    const isWebview = getWebview(); 
    if(isWebview){
      const tracker = ga.getByName(gaConstants.GA_TRACKER_NAME);
      tracker && ga(()=>{
        tracker.set('dimension17', isWebview);
      })
    }
  } catch(error){}
}

export const firePageLoadGa = (name, options) => {
  let pageLoadGa = gaConstants.PAGE_LOAD[name];
  if (!pageLoadGa) return false;

  let gaOptions = Object.assign({}, gaConstants.DEFAULT_PAGELOAD_OPTIONS, pageLoadGa.options, options);
  let gaTag = pageLoadGa.page + '?' + formurlencoded(gaOptions);

  if (typeof ga !== 'undefined' && ga) {
    setTracker();
    try {
      // _gaq.push(['_trackPageview', gaTag]);
      ga(gaConstants.GA_TRACKER_NAME + '.send', 'pageview', gaTag);
    } catch (error) {
      console.log('Ga error');
    }
  }
};


export const fireEventGa = (options) => {
  const { category, action, label, value = 0, ...rest } = options;

  if (typeof ga !== 'undefined' && ga) {
    setTracker();
    try {
      // _gaq.push(['_trackEvent', category, action, label, value, true]);
      ga(gaConstants.GA_TRACKER_NAME + '.send', 'event', {
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
        eventValue: value,
        ...rest
      });
    } catch (error) {
      console.log('Ga error');
    }
  } else {
    console.log('Google Analytics not loaded');
  }
};



// WEBPACK FOOTER //
// ../q-jobs/src/utils/GaHelper/index.js